import { DateTimeQuestion } from "./datetime-question";
import type { QuestionTypeRendererProps } from "./shared";

type DateQuestionProps = QuestionTypeRendererProps<"date">;

export default function DateQuestionType(props: DateQuestionProps) {
  return <DateTimeQuestion {...props} kind="date" />;
}
